module.exports = __webpack_public_path__ + "img/support-Ticket.f5ecfed2.jpg";